import { Component, OnInit, Input} from '@angular/core';

@Component({
    selector: 'app-return-fillup-instructions-v2',
    templateUrl: './return-fillup-instructions-v2.component.html',
    styleUrls: ['./return-fillup-instructions-v2.component.css'],
    standalone: false
})
export class ReturnFillupInstructionsV2Component implements OnInit {

  @Input() printActive: boolean

  constructor() { }

  ngOnInit(): void {
  }

}
